module.exports = __webpack_public_path__ + "static/media/CC-BY-NC.431810d6.png";